u.Storage = class extends u.BaseElement {
    /**
     * Simple storage engine with callback capabilities.
     * I'd LOVE to use ES6 proxies for this, but the current polyfill has some limitations.
     * https://github.com/GoogleChrome/proxy-polyfill
     */
    attachedCallback() {
        /**
         * 
         */
        super.attachedCallback();
        this._sep = '|';
        this._listeners = {};
        this._storage = {};
    }

    $listen(path, fn) {
        /**
         * Adds callback
         */
        if (this._listeners[path] === undefined) {
            this._listeners[path] = new Set();
        }
        this._listeners[path].add(fn);
    }

    $ignore(path, fn) {
        /**
         * Removes callback
         */
        if (this._listeners[path] !== undefined) {
            this._listeners[path].delete(fn);
        }
    }

    $set(path, value) {
        /**
         * Set value by path
         */
        // set storage
        const [obj, key] = this._pathPair(path);
        obj[key] = value;
        this.$broadcast(path);
    }

    $broadcast(path) {
        // callback listeners
        const keys = path.split(this._sep);
        for (let i = 1; i <= keys.length; i++) {
            let path = keys.slice(0, i).join(this._sep);
            if (this._listeners[path]) {
                let [obj, key] = this._pathPair(path);
                this._listeners[path].forEach(function (fn) {
                    fn(obj[key]);
                });
            }
        }
    }

    $unset(path) {
        const [obj, key] = this._pathPair(path);
        delete obj[key];
        this.$broadcast(path);
    }

    $get(path) {
        /**
         * Get value by path.
         */
        const [obj, key] = this._pathPair(path);
        return obj[key];
    }

    _pathPair(path) {
        /**
         * Get obj/key pair from path.
         */
        const keys = path.split(this._sep);
        let parent = this._storage;
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if (i === keys.length - 1) {
                return [parent, key];
            } else {
                parent = parent[key];
                if (parent === undefined) {
                    throw `Path "${path}" does not exist`;
                }
            }
        }
    }
};
